import profile_img from './account_images/profile.svg';
import dropdown_img from './account_images/dropdown.svg';
import person_img  from './account_images/person.svg';
export const AccountImage = {
    Profile: profile_img,
    DropDown: dropdown_img,
    Person: person_img
}
